<template src='./list.pug' lang='pug'></template>

<script>
import { Event } from 'vue-tables-2'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import LoadingPlaceholder from '../../../loading/LoadingPlaceholder'
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { filterByCategory } from '../../../../utils/customFilters.js'
import customSorter from '../../../../utils/customSorter.js'
import { generateLoadingRows } from '../../../../utils/grid-load-transition.js'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'OccurrenceReasonList',

  components: {
    PageTitle,
    ButtonPrimary,
    LoadingPlaceholder,
    ConfirmModal
  },

  data () {
    return {
      isLoadingData: true,
      reasons: generateLoadingRows(10),
      columns: ['codigo', 'descricao', 'categoria', 'acoes'],
      options: {
        columnsClasses: {'acoes': 'col-md-1', 'codigo': 'col-md-1', 'descricao': 'col-md-5', 'categoria': 'col-md-3'},
        headings: {
          codigo: this.$t('motivoOcorrencia.labels.sigla'),
          descricao: this.$t('motivoOcorrencia.labels.descricao'),
          categoria: this.$t('motivoOcorrencia.labels.categoria'),
          acoes: this.$t('motivoOcorrencia.labels.acoes')
        },
        templates: {
          acoes: LoadingPlaceholder,
          descricao: LoadingPlaceholder,
          categoria: LoadingPlaceholder,
          codigo: LoadingPlaceholder
        },
        filterable: ['codigo', 'descricao'],
        filterByColumn: true,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortIcon: {
          is: ''
        },
        sortable: ['codigo', 'descricao', 'categoria'],
        pagination: { chunk: 5 },
        customSorting: {
          codigo: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a, b, 'codigo')
            }
          },
          descricao: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a, b, 'descricao')
            }
          },
          categoria: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a.categoria, b.categoria, 'nome')
            }
          }
        },
        customFilters: [{
          name: 'categoria',
          callback: filterByCategory
        }]
      },
      occurrenceReasonIdToRemove: null
    }
  },

  methods: {
    handleFilter (event, column) {
      Event.$emit(`vue-tables.filter::${column}`, event.currentTarget.value)
    },

    edit (occurrenceReasonId) {
      trackAnalyticsEvent(this, 'edit-click', 'edit-motivo-de-ocorrencia', 'edit-motivo-de-ocorrencia')

      this.$store.dispatch('setOccurrenceReasonToEdit', occurrenceReasonId).then((response) => {
        this.$router.push(PATHS.NEW_OCCURRENCE_REASON)
      })
    },

    newOccurrence () {
      this.$router.push(PATHS.NEW_OCCURRENCE_REASON)
    },

    loadOccurrenceReasons () {
      let url = '/occurrenceReason/list'
      this.$store.dispatch('getOccurrenceReasons', url)
        .then((response) => {
          this.reasons = response.data.data
          this.isLoadingData = false
          this.options.templates = {
            categoria: (h, row) => {
              return row.categoria ? row.categoria.numero + ' - ' + row.categoria.nome : '-'
            }
          }
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
    },

    handleRemove (occurrenceReasonId) {
      this.occurrenceReasonIdToRemove = occurrenceReasonId
      $('#confirmRemoveOccurrence').modal('show')
    },

    removeOccurrence () {
      trackAnalyticsEvent(this, 'remove-click', 'remove-motivo-de-ocorrencia', 'remove-motivo-de-ocorrencia')
      if (this.occurrenceReasonIdToRemove) {
        this.$store.dispatch('removeOccurrenceReason', this.occurrenceReasonIdToRemove)
          .then((response) => {
            this.$root.$refs.notification.success('motivoOcorrencia.sucesso.remover')
            this.occurrenceReasonIdToRemove = null
            $('#confirmRemoveOccurrence').modal('hide')
            this.loadOccurrenceReasons()
          })
          .catch((error) => {
            this.$root.$refs.notification.error(error.message)
          })
      }
    },

    closeModalConfirm () {
      this.occurrenceReasonIdToRemove = null
      $('#confirmRemoveOccurrence').modal('hide')
    }
  },

  created () {
    this.loadOccurrenceReasons()
  }
}
</script>



// WEBPACK FOOTER //
// List.vue?6164be32